(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boutique-split-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

    function parseHours(value) {
      var ranges = [];
      if (!value) return ranges;
      var pattern = /(\d{1,2})\s*[h:.]\s*(\d{2})?\s*\D*?(\d{1,2})\s*[h:.]\s*(\d{2})?/g;
      var match;
      while ((match = pattern.exec(value)) !== null) {
        var open = parseInt(match[1], 10) * 60 + (match[2] ? parseInt(match[2], 10) : 0);
        var close = parseInt(match[3], 10) * 60 + (match[4] ? parseInt(match[4], 10) : 0);
        if (close > open) ranges.push({ open: open, close: close });
      }
      ranges.sort(function (a, b) {
        return a.open - b.open;
      });
      return ranges;
    }

    function getParisNow() {
      try {
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Paris',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        }).formatToParts(new Date());
        var values = {};
        parts.forEach(function (part) {
          values[part.type] = part.value;
        });
        return {
          day: DAY_INDEX[values.weekday],
          minutes: ((parseInt(values.hour, 10) % 24) * 60) + parseInt(values.minute, 10),
        };
      } catch (error) {
        var now = new Date();
        return { day: now.getDay(), minutes: now.getHours() * 60 + now.getMinutes() };
      }
    }

    function formatTime(minutes) {
      var hours = Math.floor(minutes / 60);
      var mins = minutes % 60;
      if (mins === 0) return hours + 'h';
      return hours + 'h' + (mins < 10 ? '0' + mins : mins);
    }

    function initHours(container) {
      var statusEl = container.querySelector('[data-boutique-hours-status]');
      var statusText = container.querySelector('[data-boutique-hours-status-text]');
      var rows = {};
      container.querySelectorAll('[data-day]').forEach(function (row) {
        rows[row.dataset.day] = row;
      });

      var now = getParisNow();
      var todayRow = rows[String(now.day)];
      if (todayRow) todayRow.classList.add('is-today');
      if (!statusEl || !statusText) return;

      var todayRanges = todayRow ? parseHours(todayRow.dataset.hours) : [];
      var currentRange = null;
      for (var i = 0; i < todayRanges.length; i++) {
        if (now.minutes >= todayRanges[i].open && now.minutes < todayRanges[i].close) {
          currentRange = todayRanges[i];
          break;
        }
      }
      var text;

      if (currentRange) {
        text = container.dataset.textOpen + ' · ' + container.dataset.textClosesAt.replace('{time}', formatTime(currentRange.close));
        statusEl.classList.add('is-open');
        if (todayRow) todayRow.classList.add('is-open');
      } else {
        statusEl.classList.add('is-closed');
        text = container.dataset.textClosed;
        for (var offset = 0; offset < 7; offset++) {
          var day = (now.day + offset) % 7;
          var row = rows[String(day)];
          if (!row) continue;
          var ranges = parseHours(row.dataset.hours);
          var next = null;
          for (var j = 0; j < ranges.length; j++) {
            if (offset > 0 || ranges[j].open > now.minutes) {
              next = ranges[j];
              break;
            }
          }
          if (!next) continue;
          var time = formatTime(next.open);
          if (offset === 0) {
            text += ' · ' + container.dataset.textOpensAt.replace('{time}', time);
          } else {
            var dayName = row.querySelector('.boutique-hours__day-name');
            text += ' · ' + container.dataset.textOpensOn
              .replace('{day}', dayName ? dayName.textContent.trim().toLowerCase() : '')
              .replace('{time}', time);
          }
          break;
        }
      }

      statusText.textContent = text;
      statusEl.hidden = false;
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-boutique-hours]').forEach(initHours);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
  constructor() {
  super();

  this.addEventListener('change', debounce((event) => {
  const body = JSON.stringify({ note: event.target.value });
  fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
  }, 300))
  }
  }

  customElements.define('cart-note', CartNote);

  class CartDeliveryEstimator extends HTMLElement {
  constructor() {
  super();
  this.elCountry = this.querySelector('.js-estimator-country');
  this.elPostalWrapper = this.querySelector('.js-estimator-postal-wrapper');
  this.elPostal = this.querySelector('.js-estimator-postal');
  this.elInternational = this.querySelector('.js-estimator-international');
  this.elFrance = this.querySelector('.js-estimator-france');
  this.elParis = this.querySelector('.js-estimator-paris');
  // Postal codes outside Paris eligible for courier delivery
  // (shop metafield custom.courier_postal_codes)
  this.courierZips = (this.dataset.courierZips || '')
  .split(',')
  .map((zip) => zip.trim())
  .filter((zip) => zip.length);

  if (!this.elCountry || !this.elPostal) return;

  this.elCountryList = this.querySelector('.js-estimator-country-list');
  // label = translated name displayed by Shopify, value = canonical English name.
  // Deduplicated by label: the tag can output the same country several times.
  const seenLabels = [];
  this.countryOptions = Array.from(this.querySelectorAll('#CartEstimatorCountryList option'))
  .map((option) => {
  const value = option.value.trim();
  const label = (option.textContent || option.value).trim();
  return { value: value, label: label };
  })
  .filter((option) => {
  if (!option.label.length) return false;
  if (option.label.indexOf('---') !== -1) return false;
  const key = this.normalize(option.label);
  if (seenLabels.indexOf(key) !== -1) return false;
  seenLabels.push(key);
  return true;
  });
  this.activeIndex = -1;

  this.elCountry.addEventListener('input', () => {
  this.update(true);
  this.renderSuggestions();
  });
  this.elCountry.addEventListener('focus', () => this.renderSuggestions());
  this.elCountry.addEventListener('blur', () => this.closeSuggestions());
  this.elCountry.addEventListener('keydown', (event) => this.onCountryKeydown(event));
  this.elPostal.addEventListener('input', () => {
  // Digits only
  const digits = this.elPostal.value.replace(/\D/g, '');
  if (digits !== this.elPostal.value) this.elPostal.value = digits;
  this.update(true);
  });
  this.restore();
  }

  normalize(value) {
  return value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  renderSuggestions() {
  const query = this.normalize(this.elCountry.value);
  if (!query) {
  this.closeSuggestions();
  return;
  }

  const matches = this.countryOptions.filter((country) => this.normalize(country.label).indexOf(query) !== -1);
  const isExactMatch = matches.length === 1 && this.normalize(matches[0].label) === query;
  if (!matches.length || isExactMatch) {
  this.closeSuggestions();
  return;
  }

  this.activeIndex = -1;
  this.elCountryList.innerHTML = '';
  matches.forEach((country) => {
  const item = document.createElement('li');
  item.setAttribute('role', 'option');
  item.textContent = country.label;
  item.addEventListener('mousedown', (event) => {
  event.preventDefault();
  this.selectCountry(country.label);
  });
  this.elCountryList.appendChild(item);
  });
  this.elCountryList.hidden = false;
  this.elCountry.setAttribute('aria-expanded', 'true');
  }

  selectCountry(label) {
  this.elCountry.value = label;
  this.closeSuggestions();
  this.update(true);
  }

  closeSuggestions() {
  this.elCountryList.hidden = true;
  this.elCountry.setAttribute('aria-expanded', 'false');
  this.activeIndex = -1;
  }

  onCountryKeydown(event) {
  if (this.elCountryList.hidden) return;
  const items = Array.from(this.elCountryList.children);

  if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
  event.preventDefault();
  const delta = event.key === 'ArrowDown' ? 1 : -1;
  this.activeIndex = (this.activeIndex + delta + items.length) % items.length;
  items.forEach((item, index) => item.classList.toggle('is-active', index === this.activeIndex));
  items[this.activeIndex].scrollIntoView({ block: 'nearest' });
  } else if (event.key === 'Enter') {
  if (this.activeIndex > -1 && items[this.activeIndex]) {
  event.preventDefault();
  this.selectCountry(items[this.activeIndex].textContent);
  }
  } else if (event.key === 'Escape') {
  this.closeSuggestions();
  }
  }

  restore() {
  let saved = {};
  try {
  saved = JSON.parse(sessionStorage.getItem('cart-delivery-estimator')) || {};
  } catch (e) {}
  if (saved.country) {
  this.elCountry.value = saved.country;
  } else if (this.dataset.customerCountry) {
  // Logged-in customer: prefill from the default address. The address
  // stores the canonical English name; display the translated label
  const cleaned = this.normalize(this.dataset.customerCountry);
  const matched = this.countryOptions.find((option) => {
  return this.normalize(option.value) === cleaned || this.normalize(option.label) === cleaned;
  });
  this.elCountry.value = matched ? matched.label : this.dataset.customerCountry;
  }
  if (saved.postal) {
  this.elPostal.value = saved.postal;
  } else if (this.dataset.customerZip) {
  this.elPostal.value = this.dataset.customerZip.replace(/\D/g, '');
  }
  this.update(false);
  }

  update(save) {
  const country = this.elCountry.value;
  const postal = this.elPostal.value;

  if (save) {
  try {
  sessionStorage.setItem('cart-delivery-estimator', JSON.stringify({ country: country, postal: postal }));
  } catch (e) {}
  }

  const cleanedCountry = this.normalize(country);
  const cleanedPostal = postal.trim();
  // Match the typed text against translated labels (and canonical values as
  // a fallback) to resolve the canonical English country name
  const matched = this.countryOptions.find((option) => {
  return this.normalize(option.label) === cleanedCountry || this.normalize(option.value) === cleanedCountry;
  });
  const isKnownCountry = !!matched;
  const isFrance = isKnownCountry && matched.value === 'France';
  // French postal code: 5 digits, department 01-98
  const isValidPostal = /^(0[1-9]|[1-8][0-9]|9[0-8])[0-9]{3}$/.test(cleanedPostal);
  // Paris intra-muros, or a bordering commune eligible for courier delivery
  const isParisPostal = /^75\d{3}$/.test(cleanedPostal) || this.courierZips.indexOf(cleanedPostal) !== -1;

  // Red state once the 5 digits are typed but don't form a valid FR postal code
  this.elPostal.classList.toggle('is-invalid', cleanedPostal.length === 5 && !isValidPostal);

  this.elPostalWrapper.hidden = !isFrance;
  this.elInternational.hidden = !isKnownCountry || isFrance;
  this.elFrance.hidden = !isFrance || !isValidPostal || isParisPostal;
  this.elParis.hidden = !isFrance || !isParisPostal;
  }
  }

  customElements.define('cart-delivery-estimator', CartDeliveryEstimator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  class ProductRecommendationsMinicart extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations-mini-cart');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(this);
    }
  }
  customElements.define('product-recommendations-mini-cart', ProductRecommendationsMinicart);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.js-quick-add');
    if (!button || button.classList.contains('is-loading')) return;

    const cartItems = button.closest('cart-items') || document.querySelector('cart-items');
    if (!cartItems) return;

    const spinner = cartItems.querySelector('#mini-cart-footer .loading-overlay__spinner');
    button.classList.add('is-loading');
    if (spinner) spinner.classList.remove('hidden');

    const body = JSON.stringify({
      items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
      sections: cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_add_url, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status && response.status !== 200) return;
        document.dispatchEvent(new CustomEvent('product:added'));
        cartItems.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        button.classList.remove('is-loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
  constructor() {
  super();

  const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;
  observer.unobserve(this);

  fetch(this.dataset.url)
  .then(response => response.text())
  .then(text => {
  const html = document.createElement('div');
  html.innerHTML = text;
  const recommendations = html.querySelector('product-recommendations');
  if (recommendations && recommendations.innerHTML.trim().length) {
  this.innerHTML = recommendations.innerHTML;
  }
  })
  .catch(e => {
  console.error(e);
  });
  }

  new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-locator-section')) {
    customElements.define(
      'store-locator-section',
      class StoreLocatorSection extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;
          this.mapElement = this.querySelector('[data-store-locator-map]');
          this.items = Array.from(this.querySelectorAll('[data-store-locator-item]'));
          this.filters = Array.from(this.querySelectorAll('[data-store-locator-filter]'));
          this.countElement = this.querySelector('[data-store-locator-count]');
          this.apiKey = this.dataset.apiKey || '';
          this.defaultLatitude = parseFloat(this.dataset.defaultLatitude || '');
          this.defaultLongitude = parseFloat(this.dataset.defaultLongitude || '');
          this.initialZoom = parseInt(this.dataset.initialZoom || '11', 10);
          this.accentColor = this.dataset.accentColor || '#d8232a';
          this.directionsLabel = this.dataset.directionsLabel || '';
          this.detailsLabel = this.dataset.detailsLabel || '';
          this.countLabelSingular = this.dataset.countLabelSingular || '';
          this.countLabelPlural = this.dataset.countLabelPlural || '';
          this.closeLabel = this.dataset.closeLabel || 'Close';
          this.mapFallback = this.dataset.mapFallback || '';
          this.enableClustering = this.dataset.enableClustering !== 'false';
          this.markerIconType = this.dataset.markerIconType || 'classic';
          this.activeIndex = -1;
          this.map = null;
          this.infoWindow = null;
          this.markers = [];
          this.clusterer = null;
          this.ready = false;
          this.activeFilter = 'all';

          this.setupListInteractions();
          this.setupFilterInteractions();
          this.applyFilter(this.activeFilter, false);

          if (this.mapElement && this.apiKey) {
            this.loadMap();
          }
        }

        setupListInteractions() {
          this.items.forEach((item, index) => {
            item.addEventListener('click', (event) => {
              if (event.target.closest('a')) return;
              this.activateStore(index, true, false);
            });

            item.addEventListener('keydown', (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              if (event.target.closest('a')) return;
              event.preventDefault();
              this.activateStore(index, true, false);
            });
          });
        }

        setupFilterInteractions() {
          this.filters.forEach((filter) => {
            filter.addEventListener('click', () => {
              this.applyFilter(filter.dataset.cityFilter || 'all', true);
            });
          });
        }

        applyFilter(filterValue, moveMap) {
          this.activeFilter = filterValue || 'all';
          let visibleCount = 0;

          this.filters.forEach((filter) => {
            const isActive = (filter.dataset.cityFilter || 'all') === this.activeFilter;
            filter.classList.toggle('is-active', isActive);
            filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          this.items.forEach((item, index) => {
            const cityKey = item.dataset.cityKey || '';
            const isVisible = this.activeFilter === 'all' || cityKey === this.activeFilter;
            item.hidden = !isVisible;
            item.classList.toggle('is-hidden-by-filter', !isVisible);

            if (this.markers[index]) {
              this.markers[index].setVisible(isVisible);
            }

            if (isVisible) {
              visibleCount += 1;
            } else {
              item.classList.remove('is-active');
              item.removeAttribute('aria-current');
            }
          });

          if (this.countElement) {
            this.countElement.textContent = `${visibleCount} ${
              visibleCount === 1 ? this.countLabelSingular : this.countLabelPlural
            }`;
          }

          if (this.map) {
            this.fitMapToVisibleStores();
          }

          const activeItem = this.items[this.activeIndex];
          if (!activeItem || activeItem.hidden) {
            this.clearActiveStore();
          }
        }

        clearActiveStore() {
          this.activeIndex = -1;
          this.items.forEach((item) => {
            item.classList.remove('is-active');
            item.removeAttribute('aria-current');
          });

          if (this.infoWindow) {
            this.infoWindow.close();
          }
        }

        activateStore(index, focusMap, scrollList = true) {
          const item = this.items[index];
          if (!item) return;

          const isSameActiveStore = this.activeIndex === index;
          this.activeIndex = index;

          this.items.forEach((item, itemIndex) => {
            const isActive = itemIndex === index;
            item.classList.toggle('is-active', isActive);
            if (isActive) {
              item.setAttribute('aria-current', 'true');
            } else {
              item.removeAttribute('aria-current');
            }
          });

          if (focusMap && this.map && this.markers[index]) {
            const marker = this.markers[index];
            const position = marker.getPosition();
            if (position) {
              if (this.map.getZoom() < Math.max(this.initialZoom, 14)) {
                this.map.setZoom(Math.max(this.initialZoom, 14));
              }

              const projection = this.map.getProjection();
              if (projection) {
                const scale = Math.pow(2, this.map.getZoom());
                const isMobile = window.innerWidth < 750;
                const offset = isMobile ? 180 : 120;
                const markerPoint = projection.fromLatLngToPoint(position);
                const offsetCenter = projection.fromPointToLatLng(
                  new google.maps.Point(markerPoint.x, markerPoint.y - offset / scale)
                );
                this.map.panTo(offsetCenter);
              } else {
                this.map.panTo(position);
              }
            }
            this.openInfoWindow(item, marker);

            if (window.innerWidth < 750) {
              this.scrollMapIntoView();
            }
          } else if (isSameActiveStore && scrollList) {
            this.scrollItemInList(item);
            return;
          }

          if (scrollList) {
            this.scrollItemInList(item);
          }
        }

        scrollItemInList(item) {
          const list = this.querySelector('.store-locator__list');
          if (!list || !item) return;

          const itemTop = item.offsetTop;
          const targetTop = itemTop - (list.clientHeight - item.clientHeight) / 2;
          list.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: 'smooth',
          });
        }

        scrollMapIntoView() {
          const mapColumn = this.querySelector('.store-locator__map-column');
          if (mapColumn) {
            mapColumn.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }

        openInfoWindow(item, marker) {
          if (!this.infoWindow || !marker) return;

          const name = item.dataset.name || '';
          const displayAddress = item.dataset.displayAddress || item.dataset.streetAddress || '';
          const country = item.dataset.country || '';
          const imageUrl = item.dataset.imageUrl || '';
          const directionsUrl = item.dataset.directionsUrl || '';
          const detailsUrl = item.dataset.detailsUrl || '';
          const phone = item.dataset.phone || '';
          const phoneDisplay = item.dataset.phoneDisplay || phone;

          const wrapper = document.createElement('div');
          wrapper.className = 'store-locator-info-window';

          const closeButton = document.createElement('button');
          closeButton.type = 'button';
          closeButton.className = 'store-locator-info-window__close';
          closeButton.setAttribute('aria-label', this.closeLabel);
          closeButton.textContent = '×';
          closeButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.infoWindow.close();
          });
          wrapper.appendChild(closeButton);

          if (imageUrl) {
            const image = document.createElement('img');
            image.className = 'store-locator-info-window__image';
            image.src = imageUrl;
            image.alt = name;
            image.loading = 'lazy';
            wrapper.appendChild(image);
          } else {
            const placeholder = document.createElement('div');
            placeholder.className = 'store-locator-info-window__image store-locator-info-window__image--placeholder';
            placeholder.innerHTML = `
              <svg viewBox="0 0 96 96" aria-hidden="true" focusable="false">
                <rect x="16" y="38" width="64" height="38" rx="3" fill="currentColor" opacity="0.14"></rect>
                <path d="M20 40 48 18l28 22" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M32 76V52h32v24" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"></path>
                <path d="M39 64c5-9 13-9 18 0-3 4-15 4-18 0Z" fill="currentColor"></path>
              </svg>
            `;
            wrapper.appendChild(placeholder);
          }

          const title = document.createElement('div');
          title.className = 'store-locator-info-window__title';
          title.textContent = name;
          wrapper.appendChild(title);

          const addressLines = [];
          if (displayAddress) {
            addressLines.push(displayAddress);
          } else if (country) {
            addressLines.push(country);
          }

          if (addressLines.length) {
            const addressLink = document.createElement(directionsUrl ? 'a' : 'div');
            addressLink.className = 'store-locator-info-window__row';
            if (directionsUrl) {
              addressLink.href = directionsUrl;
              addressLink.target = '_blank';
              addressLink.rel = 'noopener noreferrer';
            }
            addressLink.appendChild(this.createInfoIcon('marker'));

            const addressText = document.createElement('span');
            addressText.className = 'store-locator-info-window__address';

            addressLines.forEach((line, lineIndex) => {
              const addressLine = document.createElement('span');
              addressLine.className = 'store-locator-info-window__address-line';
              addressLine.textContent = line;
              addressText.appendChild(addressLine);
            });

            addressLink.appendChild(addressText);
            wrapper.appendChild(addressLink);
          }

          if (phone) {
            const phoneLink = document.createElement('a');
            phoneLink.className = 'store-locator-info-window__row';
            phoneLink.href = `tel:${phone.replace(/\s+/g, '')}`;
            phoneLink.appendChild(this.createInfoIcon('phone'));

            const phoneText = document.createElement('span');
            phoneText.textContent = phoneDisplay;
            phoneLink.appendChild(phoneText);
            wrapper.appendChild(phoneLink);
          }

          const links = document.createElement('div');
          links.className = 'store-locator-info-window__links';

          if (directionsUrl) {
            const directionsLink = document.createElement('a');
            directionsLink.className = 'store-locator-info-window__link';
            directionsLink.href = directionsUrl;
            directionsLink.target = '_blank';
            directionsLink.rel = 'noopener noreferrer';
            directionsLink.textContent = this.directionsLabel;
            links.appendChild(directionsLink);
          }

          if (detailsUrl) {
            if (links.childElementCount) {
              const separator = document.createElement('span');
              separator.className = 'store-locator-info-window__separator';
              separator.textContent = '•';
              links.appendChild(separator);
            }

            const detailsLink = document.createElement('a');
            detailsLink.className = 'store-locator-info-window__link';
            detailsLink.href = detailsUrl;
            detailsLink.textContent = this.detailsLabel;
            links.appendChild(detailsLink);
          }

          if (links.childElementCount) {
            wrapper.appendChild(links);
          }

          this.infoWindow.setContent(wrapper);
          this.infoWindow.open({ map: this.map, anchor: marker });
        }

        createInfoIcon(type) {
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('class', 'store-locator-info-window__icon');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('aria-hidden', 'true');
          icon.setAttribute('focusable', 'false');

          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('fill', 'currentColor');

          if (type === 'phone') {
            path.setAttribute(
              'd',
              'M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.3 1.2.4 2.4.6 3.7.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.8 21 3 13.2 3 3.8c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.7.1.4 0 .8-.3 1.1l-2.2 2.2Z'
            );
          } else {
            path.setAttribute(
              'd',
              'M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z'
            );
          }

          icon.appendChild(path);
          return icon;
        }

        fitMapToVisibleStores() {
          if (!this.map || !window.google || !window.google.maps) return;

          const visibleMarkers = this.markers.filter((marker) => marker && marker.getVisible());

          if (visibleMarkers.length > 1) {
            const bounds = new google.maps.LatLngBounds();
            visibleMarkers.forEach((marker) => {
              const position = marker.getPosition();
              if (position) {
                bounds.extend(position);
              }
            });
            this.map.fitBounds(bounds, 64);
          } else if (visibleMarkers.length === 1) {
            const position = visibleMarkers[0].getPosition();
            if (position) {
              this.map.panTo(position);
              this.map.setZoom(Math.max(this.initialZoom, 13));
            }
          }
        }

        loadMap() {
          if (window.google && window.google.maps && window.markerClusterer) {
            this.initMap();
            return;
          }

          if (!window.__storeLocatorGoogleMapsPromise) {
            window.__storeLocatorGoogleMapsPromise = new Promise((resolve, reject) => {
              const existingScript = document.getElementById('StoreLocatorGoogleMapsScript');
              if (existingScript) {
                existingScript.addEventListener('load', resolve, { once: true });
                existingScript.addEventListener(
                  'error',
                  () => {
                    window.__storeLocatorGoogleMapsPromise = null;
                    reject(new Error('Google Maps failed to load'));
                  },
                  { once: true }
                );
                return;
              }

              let loadedCount = 0;
              const loadComplete = () => {
                loadedCount++;
                if (loadedCount === 2) resolve();
              };

              window.__storeLocatorGoogleMapsInit = loadComplete;

              const script = document.createElement('script');
              script.id = 'StoreLocatorGoogleMapsScript';
              script.async = true;
              script.defer = true;
              script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
                this.apiKey
              )}&callback=__storeLocatorGoogleMapsInit`;
              script.onerror = () => {
                window.__storeLocatorGoogleMapsPromise = null;
                reject(new Error('Google Maps failed to load'));
              };
              document.head.appendChild(script);

              const markerClustererScript = document.createElement('script');
              markerClustererScript.src =
                'https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.0.0/dist/index.min.js';
              markerClustererScript.async = true;
              markerClustererScript.onerror = () => {
                window.__storeLocatorGoogleMapsPromise = null;
                reject(new Error('MarkerClusterer failed to load'));
              };
              markerClustererScript.onload = loadComplete;
              document.head.appendChild(markerClustererScript);
            });
          }

          window.__storeLocatorGoogleMapsPromise
            .then(() => {
              this.initMap();
            })
            .catch(() => {
              if (this.mapElement) {
                const fallback = document.createElement('div');
                fallback.className = 'store-locator__map-fallback';
                fallback.textContent = this.mapFallback;
                this.mapElement.replaceChildren(fallback);
              }
            });
        }

        initMap() {
          if (this.ready || !this.mapElement || !window.google || !window.google.maps) return;
          this.ready = true;

          const validStores = this.items
            .map((item, index) => {
              const latitude = parseFloat(item.dataset.latitude || '');
              const longitude = parseFloat(item.dataset.longitude || '');

              if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
                return null;
              }

              return {
                index,
                item,
                position: { lat: latitude, lng: longitude },
              };
            })
            .filter(Boolean);

          const fallbackCenter = {
            lat: Number.isFinite(this.defaultLatitude) ? this.defaultLatitude : 48.8566,
            lng: Number.isFinite(this.defaultLongitude) ? this.defaultLongitude : 2.3522,
          };

          this.map = new google.maps.Map(this.mapElement, {
            center: fallbackCenter,
            zoom: this.initialZoom,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: true,
            clickableIcons: false,
            gestureHandling: 'greedy',
            styles: [
              { elementType: 'geometry', stylers: [{ color: '#efe7d8' }] },
              { elementType: 'labels.text.fill', stylers: [{ color: '#8a7864' }] },
              { elementType: 'labels.text.stroke', stylers: [{ color: '#faf8f6' }] },
              { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#d8c9ad' }] },
              { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#e8dcc5' }] },
              { featureType: 'poi', stylers: [{ visibility: 'off' }] },
              { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dcd0b4' }] },
              { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#faf8f6' }] },
              { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#e3d8c4' }] },
              { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#fbf9f5' }] },
              { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#f0e6d2' }] },
              { featureType: 'transit', stylers: [{ visibility: 'off' }] },
              { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#cdbf9f' }] },
              { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#a8967a' }] },
            ],
          });

          this.infoWindow = new google.maps.InfoWindow({
            disableAutoPan: true,
          });

          const accentColor = this.accentColor || '#d8232a';

          if (this.enableClustering) {
            this.clusterer = new markerClusterer.MarkerClusterer({
              map: this.map,
              markers: [],
              renderer: {
                render: (cluster) => {
                  const svg = window.btoa(`
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
                      <circle cx="28" cy="28" r="28" fill="${accentColor}"/>
                      <text x="28" y="34" text-anchor="middle" font-size="18" font-weight="600" fill="white" font-family="Arial">${cluster.count}</text>
                    </svg>
                  `);

                  return new google.maps.Marker({
                    position: cluster.position,
                    icon: {
                      url: `data:image/svg+xml;base64,${svg}`,
                      scaledSize: new google.maps.Size(56, 56),
                      anchor: new google.maps.Point(28, 28),
                    },
                    title: `${cluster.count} ${this.countLabelPlural}`,
                  });
                },
              },
            });
          }

          const createClassicIcon = (color) => {
            const svg = `
              <svg xmlns="http://www.w3.org/2000/svg" width="38" height="50" viewBox="0 0 38 50">
                <path d="M19 0C8.5 0 0 8.5 0 19c0 12.4 19 31 19 31s19-18.6 19-31C38 8.5 29.5 0 19 0Z" fill="${color}"/>
                <circle cx="19" cy="19" r="7.5" fill="#fff"/>
                <circle cx="19" cy="19" r="3.5" fill="${color}"/>
              </svg>
            `;

            return {
              url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
              scaledSize: new google.maps.Size(38, 50),
              anchor: new google.maps.Point(19, 50),
            };
          };

          const createCircleWithBread = (color) => {
            const svg = `
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="24" fill="${color}"/>
                <g transform="rotate(-18 24 24)">
                  <ellipse cx="24" cy="24" rx="13" ry="7.5" fill="#fff"/>
                  <path d="M18 20.8l1.8 5.6M23.3 20l1.8 6M28.6 20.8l1.8 5.6" fill="none" stroke="${color}" stroke-width="1.7" stroke-linecap="round"/>
                </g>
              </svg>
            `;

            return {
              url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
              scaledSize: new google.maps.Size(48, 48),
              anchor: new google.maps.Point(24, 24),
            };
          };

          const createCircleWithCroissant = (color) => {
            const svg = `
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="24" fill="${color}"/>
                <g fill="#fff">
                  <ellipse cx="24" cy="23" rx="6.2" ry="7.5"/>
                  <ellipse cx="15.5" cy="25.5" rx="5.2" ry="4.2" transform="rotate(-32 15.5 25.5)"/>
                  <ellipse cx="32.5" cy="25.5" rx="5.2" ry="4.2" transform="rotate(32 32.5 25.5)"/>
                  <circle cx="10.8" cy="29.5" r="2.1"/>
                  <circle cx="37.2" cy="29.5" r="2.1"/>
                </g>
                <path d="M19 17.5 17.5 27.5M29 17.5l1.5 10" fill="none" stroke="${color}" stroke-width="1.4" stroke-linecap="round"/>
              </svg>
            `;

            return {
              url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
              scaledSize: new google.maps.Size(48, 48),
              anchor: new google.maps.Point(24, 24),
            };
          };

          let markerIcon;
          switch (this.markerIconType) {
            case 'bread':
              markerIcon = createCircleWithBread(this.accentColor || '#8a5a2b');
              break;
            case 'croissant':
              markerIcon = createCircleWithCroissant(this.accentColor || '#8a5a2b');
              break;
            case 'classic':
            default:
              markerIcon = createClassicIcon(this.accentColor || '#d8232a');
              break;
          }

          this.markers = this.items.map((item) => {
            const latitude = parseFloat(item.dataset.latitude || '');
            const longitude = parseFloat(item.dataset.longitude || '');

            if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
              return null;
            }

            const marker = new google.maps.Marker({
              position: { lat: latitude, lng: longitude },
              icon: markerIcon,
              title: item.dataset.name || '',
              map: this.clusterer ? null : this.map,
            });

            marker.addListener('click', () => {
              const index = Number(item.dataset.index || '0');
              this.activateStore(index, true);
            });

            if (this.clusterer) {
              this.clusterer.addMarker(marker);
            }
            return marker;
          });

          if (validStores.length > 1) {
            const bounds = new google.maps.LatLngBounds();
            validStores.forEach((store) => bounds.extend(store.position));
            this.map.fitBounds(bounds, 64);
            google.maps.event.addListenerOnce(this.map, 'idle', () => {
              if (this.map.getZoom() > this.initialZoom + 2) {
                this.map.setZoom(this.initialZoom + 2);
              }
              if (window.matchMedia('(max-width: 749px)').matches) {
                this.map.setZoom(this.map.getZoom() - 0.5);
              }
            });
          } else if (validStores.length === 1) {
            this.map.setCenter(validStores[0].position);
            this.map.setZoom(this.initialZoom);
          } else {
            this.map.setCenter(fallbackCenter);
            this.map.setZoom(this.initialZoom);
          }

          this.applyFilter(this.activeFilter, false);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
